import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const IconProviderGivme = ({ className }) => (
  <svg className={classNames('producers-svg-icon', className)} xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <path d="M15.3985 5.99952C14.8404 5.20278 14.1257 4.57979 13.2543 4.12959C12.382 3.67939 11.4562 3.4538 10.4751 3.4538C8.8159 3.4538 7.51402 3.87809 6.56669 4.72378C5.61842 5.57139 4.94966 6.42669 4.56134 7.29062C4.17209 8.15551 3.977 9.03672 3.977 9.93521C3.977 10.7473 4.13364 11.546 4.44691 12.3331C4.76019 13.1193 5.39049 14.0187 6.33783 15.0295C7.2861 16.0403 8.7146 16.5452 10.6271 16.5452C11.7273 16.5452 12.7891 16.2275 13.8124 15.592C14.8357 14.9566 15.602 14.131 16.1094 13.1164L8.26626 13.1164V9.76626H20.5V10.18C20.5 12.9436 19.5189 15.2714 17.5567 17.1625C15.5926 19.0545 13.2496 20 10.5258 20C7.80104 20 5.44958 19.0401 3.46956 17.1202C1.49048 15.2004 0.5 12.8486 0.5 10.0648C0.5 7.26278 1.4811 4.88505 3.44424 2.93064C5.40738 0.977201 7.75039 0 10.4751 0C12.4205 0 14.2476 0.544277 15.9575 1.63571C17.6655 2.72714 18.867 4.18143 19.5611 5.99952H15.3985Z" fill="white" />
  </svg>
);

IconProviderGivme.propTypes = {
  className: PropTypes.string,
};
IconProviderGivme.defaultProps = {
  className: null,
};
